import { useDataWrapper, useSetDataWrapper } from '@powerednow/components/DataWrapperProvider/DataWrapperProvider';
import React, { useEffect } from 'react';
import { DataWrapper } from '@powerednow/app/FieldServices/singletons/DataWrapper';

function withDataWrapper <T>(WrappedComponent: React.ComponentType<T>) {
    return function (props: T) {
        const dataWrapper = useDataWrapper();
        const setDataWrapper = useSetDataWrapper();

        useEffect(() => {
            if (!dataWrapper) {
                setDataWrapper(DataWrapper);
            }
        }, [dataWrapper]);

        if (!dataWrapper) {
            return null;
        }

        return <WrappedComponent {...props as T} />;
    };
}

export default withDataWrapper;
